var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "splicing-object-table-row",
      class: {
        lastRow:
          _vm.objectType === "cable"
            ? !_vm.isOneFiber() && _vm.isLastRowOfTube()
            : false
      }
    },
    [
      _vm.objectType === "cable"
        ? _c(
            "table-data-tube",
            {
              attrs: {
                "tube-number": _vm.tubeNumber,
                "fiber-per-tube-cache": _vm.fiberPerTubeCache,
                tubeColor: _vm.tubeColor,
                "is-selected": _vm.tubeIsSelected,
                disabled: _vm.disabled
              },
              on: {
                click: function($event) {
                  return _vm.$emit("select-tube")
                },
                contextmenu: function($event) {
                  return _vm.$emit("open-menu-tube", $event)
                }
              }
            },
            [
              _c("connection-point-name", {
                attrs: {
                  name: _vm.tubeNumber,
                  "is-selected": _vm.tubeIsSelected
                }
              }),
              _vm._v(" "),
              _c("tube-color-icon", { attrs: { "icon-color": _vm.tubeColor } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table-data-connection-point",
        {
          staticStyle: { "padding-right": "0" },
          attrs: {
            "is-selected": _vm.connectionPointIsSelected,
            "justify-end": true,
            disabled: _vm.disabled,
            "last-tube":
              _vm.objectType === "cable" ? _vm.isLastRowOfTube() : false
          },
          on: {
            click: function($event) {
              return _vm.$emit("select-connection-point")
            },
            contextmenu: function($event) {
              return _vm.$emit("open-menu-connection-point", $event)
            }
          }
        },
        [
          _c("connection-point-name", {
            attrs: {
              name: _vm.connectionPointName,
              "is-selected": _vm.connectionPointIsSelected,
              "number-in-cable": _vm.numberInCable,
              side: "origin"
            }
          }),
          _vm._v(" "),
          _c("connection-point-color-icon", {
            attrs: { "icon-color": _vm.connectionPointColor }
          }),
          _vm._v(" "),
          _c("connection-point-connection-icon", {
            attrs: {
              "connection-type": _vm.connectionType,
              state: _vm.state,
              side: "origin"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04635cfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04635cfe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableRowOrigin.vue
// module id = null
// module chunks = 